import { type Locale } from "@/lib/site";
import { enContent } from "./en";
import { zhContent } from "./zh";

export type SiteContent = typeof zhContent;

export function getSiteContent(locale: Locale): SiteContent {
  return locale === "en" ? enContent : zhContent;
}

export { zhContent, enContent };
